var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "27px",
    viewBox: "0 0 30 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "heart_active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-244.000000, -3150.000000)",
    fill: "#F5416D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 3034.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(168.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.47440568,14.1083756 L14.48613,25.8589755 C14.7699327,26.1366085 15.2300673,26.1366085 15.51387,25.8589755 L27.5255943,14.1083756 C30.8248019,10.8808899 30.8248019,5.64810133 27.5255943,2.42061425 C24.2263853,-0.806871416 18.8773125,-0.806871416 15.578105,2.42061425 C15.120761,2.86801458 15,3.06430791 15,3.06430791 C15,3.06430791 14.6366837,2.63073363 14.421895,2.42061425 C11.1226875,-0.806871416 5.7736147,-0.806871416 2.47440568,2.42061425 C-0.824801892,5.64810133 -0.824801892,10.8808899 2.47440568,14.1083756 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartActive);
export default __webpack_public_path__ + "static/media/heart_active.35a40d151f81045652d5ab1d3821d325.svg";
export { ForwardRef as ReactComponent };